import { render } from "./BaseButton.vue?vue&type=template&id=656f4eea&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=656f4eea&lang=scss"
import "./BaseButton.vue?vue&type=style&index=1&id=656f4eea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656f4eea"]])

export default __exports__